export default __webpack_public_path__ + "static/media/cal_bg14.ebdffe2c.jpg";